const actions = {
  FETCH_DATA: "FETCH_DATA",
  FETCH_VAULTS: "FETCH_VAULTS",
  FETCH_DEVICES: "FETCH_DEVICES"
};

export default actions;
